import {
  Component,
  OnInit,
  ChangeDetectorRef,
  AfterViewInit
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ShoppingCartService } from '../../shopping-cart/shopping-cart.service';
import { fileValidator } from '../../validators/file-validator';
import { RequestModel } from '../../shopping-cart/request-model.model';
import { stateValidator } from '../../validators/state-validator';
import { TrimFormControl } from '../trim-control';
import { TouchFormControl } from '../../validation-banner/touch-form-control.modal';
import { ResignationService } from '../../resig-service/resignation.service';
import { ProviderTypeService } from '../../prov-service/provider-type.service';
import { RequestTypeService } from '../../req-type/request-type.service';
import { KeyValue } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal';
import { EventService } from 'src/app/main/event-service/event.service';
import { State } from '../state.model';

@Component({
  selector: 'app-resignation',
  templateUrl: './resignation.component.html',
  styleUrls: ['../../app.component.scss']
})
export class ResignationComponent implements OnInit, AfterViewInit {
  public myForm: FormGroup;
  public doc: File;
  private _index = null;
  private _request: RequestModel;
  private _duplicated: RequestModel = null;
  public gatewayMed = false;
  private _emitRequest: RequestModel;
  public group = false;
  private _reqToggle = 'new';
  private _showBanner = false;
  private _optDocs: File[] = [];

  constructor(
    private cartService: ShoppingCartService,
    private ref: ChangeDetectorRef,
    private resService: ResignationService,
    private providerService: ProviderTypeService,
    private requestTypeService: RequestTypeService,
    private modalService: BsModalService,
    private eventService: EventService
  ) {}

  ngAfterViewInit(): void {
    this.myForm.controls['reasonForResignation'].setValue(
      this.request
        ? this.request.reasonForResignation
        : this.duplicated
        ? this.duplicated.reasonForResignation
        : ''
    );
    this.reqToggle = this.index != null ? 'update' : 'new';
    this.ref.detectChanges();
  }

  ngOnInit() {
    this.myForm = new FormGroup({
      name: new TrimFormControl('', [
        Validators.required,
        Validators.pattern(/^[A-Za-z0-9\&\-\,\.\/\:\#\'\(\) ]+$/)
      ]),
      middleInitial: new TrimFormControl('', Validators.pattern(/^[A-Za-z]+$/)),
      lastName: new TrimFormControl('', [
        Validators.required,
        Validators.pattern(/^[A-Za-z0-9\&\-\,\.\/\:\#\'\(\) ]+$/)
      ]),
      idType: new TouchFormControl('NPI', [Validators.required]),
      NPI: new TrimFormControl('', [Validators.required]),
      taxID: new TrimFormControl('', []),
      providerID: new TrimFormControl('', []),
      country: new TrimFormControl('US', [Validators.required]),
      requestDetails: new TrimFormControl('', [Validators.required]),
      doc: new FormControl('', [Validators.required, fileValidator()]),
      reasonForResignation: new TrimFormControl('', [Validators.required]),
      providerType: new TouchFormControl(''),
      requestType: new TouchFormControl(''),
      optDoc: new TouchFormControl('')
    });

    this.index = this.eventService.request;
    this.request = this.cartService.getSingleRequest(this.index);
    this.duplicated = this.eventService.requestModel;

    if (this.index !== null && this.myForm.controls['country'].value === 'US') {
      this.myForm.addControl(
        'state',
        new TrimFormControl('', [Validators.required, stateValidator([])])
      );
      this.optDocs = this.request.optDocs;
    }
    else if (this.duplicated !== null && this.myForm.controls['country'].value === 'US') {
      this.myForm.addControl(
        'state',
        new TrimFormControl('', [Validators.required, stateValidator([])])
      );
    }
    else {
      this.myForm.addControl(
        'state',
        new TrimFormControl('', [Validators.required, stateValidator([])])
      );
    }
  }

  valueAscOrder = (
    a: KeyValue<number, string>,
    b: KeyValue<number, string>
  ): number => {
    return a.value.localeCompare(b.value);
  }

  public updateFile(doc: any): void {
    this.doc = doc;
  }

  public updateOptFile(docs: any): void {
    if (docs) {
      this.optDocs = docs;
    }
  }

  public updateRequest(emitRequest: any) {
    this.emitRequest = emitRequest;
  }

  public closeParent(close?: any): void {
    this.modalService._hideModal();
    this.modalService._hideBackdrop();
    
    let valid = true;

    if (close !== undefined) {
      valid = close;
    }

    this.eventService.confirmEvent.emit(new State(false, valid, this.reqToggle));
  }

  public submit(): void {
    if (this.submittable()) {
      const request = this.myForm.value;
      const type = 'P02';
      request.providerType = this.providerService.provider[type];
      const reqType = 'R03';
      request.requestType = this.requestTypeService.reqType[reqType];
      request.fileType = this.doc.type;
      request.doc = this.doc;
      request.optDocs = this.optDocs;

      if (this.emitRequest) {
        request.state = this.emitRequest.state;
        request.gateway = this.emitRequest.gateway
          ? this.emitRequest.gateway
          : false;
      }
      else {
        request.state = null;
        request.gateway = false;
      }

      this._showBanner = false;
      this.closeParent();
      this.request
        ? this.cartService.editRequest(this.index, request)
        : this.cartService.addToCart(request);
    }
    else if (this.myForm.invalid) {
      this._showBanner = true;
    }
  }

  public get resign(): any {
    return this.resService.resReasons;
  }

  public get reqToggle() {
    return this._reqToggle;
  }

  public set reqToggle(reqToggle: string) {
    this._reqToggle = reqToggle;
  }

  public get optDocs(): File[] {
    return this._optDocs;
  }

  public set optDocs(value: File[]) {
    this._optDocs = value;
  }

  public get duplicated(): RequestModel {
    return this._duplicated;
  }

  public set duplicated(value: RequestModel) {
    this._duplicated = value;
  }

  public get emitRequest(): RequestModel {
    return this._emitRequest;
  }

  public set emitRequest(value: RequestModel) {
    this._emitRequest = value;
  }

  public get request(): RequestModel {
    return this._request;
  }
  
  public set request(value: RequestModel) {
    this._request = value;
  }

  public get index() {
    return this._index;
  }
  
  public set index(value) {
    this._index = value;
  }

  public get showBanner(): boolean {
    return this._showBanner && this.myForm.touched && !this.myForm.valid;
  }

  public submittable(): boolean {
    return this.myForm.touched && this.myForm.valid;
  }
}
